import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProduct, setHmcw } from '../actions/packageSelection';
import { STEP_FORM_FIELDS } from './components/helpMeChooseWizard/fields/stepFields';
import StepOne from './components/helpMeChooseWizard/steps/stepOne';
import StepTwo from './components/helpMeChooseWizard/steps/stepTwo';
import StepThree from './components/helpMeChooseWizard/steps/stepThree';
import StepFour from './components/helpMeChooseWizard/steps/stepFour';
import WizardButtons from './components/helpMeChooseWizard/wizardButtons';
import FooterComponent from './components/helpMeChooseWizard/footer';
import { fetchQuote, setHelpMeChooseInput } from '../actions/packageConfiguration';
import { useParams } from 'react-router';
import history from './../history';


import './HelpMeChooseWizardPage.css'

function HelpMeChooseWizardPage({ SegmentAnalytics }) {
  const { helpMeChoose } = useParams();

  const [isValid, setIsValid] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [recommendedPackage, setRecommendedPackage] = useState({});
  const [geographyOptions, setGeographyOptions] = useState([]);
  const [showModal, setModal] = useState(false);
  const [productPackageQuote, setProductPackageQuote] = useState({});
  const [productConfiguration, setProductConfiguration] = useState({});
  const [mobile, setMobile] = useState(false);

  const FRIENDLY_NAME = 'rp-data-professional';
  const INDUSTRY_KEY = 'real_estate_agencies_and_valuers';

  const problemsOptions = [
    { value: 'Lead generation', label: 'Lead generation' },
    { value: 'Research and market knowledge', label: 'Research and market knowledge' },
    { value: 'Data and business intelligence', label: 'Data and business intelligence' },
    { value: 'Recent sales', label: 'Recent sales' },
    { value: 'Auction results', label: 'Auction results' },
    { value: 'Other', label: 'Other' }
  ];

  const product = useSelector((state) => state.packageSelection);
  const productQuote = useSelector((state) => state.packageConfiguration);
  const coupon = useSelector((state) => state.packageSelection.coupon);

  const dispatch = useDispatch();
  const dispatchSetHelpMeChooseInput = (inputValues) => {
    dispatch(setHelpMeChooseInput(inputValues));
  };

  function handleChange(event, inputName = null) {
    let inputState = productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS;
    if (event.target) {
      const { name, value } = event.target;
      inputState[name].value = value;
      if (inputState[name].required) {
        inputState[name].error = value ? false : true;
      }
      dispatchSetHelpMeChooseInput(inputState);
    } else if (inputName !== null) {
      // handle form arrays - multi select
      inputState[inputName].value = event;
      if (inputState[inputName].required) {
        inputState[inputName].error = event ? false : true;
      }
      dispatchSetHelpMeChooseInput(inputState);
    }
    setIsValid(true);
  }

  function handleValidation(isStepCheck) {
    let inputState = productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS;
    let inputError = false;
    for (let key of Object.keys(inputState)) {
      //validity determines if all the required fields are entered
      //1. check if the field is required
      //2. check if the validation is for a step;
      //.  a. if isStepCheck is true then check if the current step is equal to the input field's step
      //.  b. if isStepCheck is false then check all required fields in the form (Step 1,2 and 3)
      //3. Check if the value in the field is empty
      let validity =
        inputState[key].required &&
        ((isStepCheck && inputState[key].step === currentStep) || !isStepCheck) &&
        (inputState[key].value === null || inputState[key].value.length === 0);
      inputState[key].error = validity;
      dispatchSetHelpMeChooseInput(inputState);
      if (!inputError && validity) {
        inputError = true;
      }
    }
    // if errors that is "inputError" then setIsValid = false
    setIsValid(!inputError);
    return !inputError;
  }

  const handleSubmit = (event = null, redirect = false) => {
    if (event) {
      event.preventDefault(); // prevent refresh
    }
    if (handleValidation(false)) {
      let inputValues = productQuote.hmcInputValues;
      let assignedRecommendedPackage = assignRecommendedPackage(inputValues);
      if (assignedRecommendedPackage) {
        fetchProductQuote(assignedRecommendedPackage);
      }
      setCurrentStep(4);

      if (redirect) {
        SegmentAnalytics.trackStepResponse(4, inputValues);
        history.push('help-me-choose-recommendation');
      }
    }
  };

  function handleEditChange(event, newName = null) {
    let inputState = productQuote.hmcInputValues;
    if (event.target) {
      const { name, value } = event.target;
      inputState[name].tempValue = value;
      if (inputState[name].required) {
        inputState[name].error = value ? false : true;
      }
      SegmentAnalytics.trackHmcwEdit('Edit Selection Option Picked', null, name, value);
      dispatchSetHelpMeChooseInput(inputState);
    } else if (newName !== null) {
      // handle form arrays - multi select
      inputState[newName].tempValue = event;
      if (inputState[newName].required) {
        inputState[newName].error = event && event.length > 0 ? false : true;
      }
      SegmentAnalytics.trackHmcwEdit('Edit Selection Option Picked', null, newName, event);
      dispatchSetHelpMeChooseInput(inputState);
    }
  }

  function saveChange(event, name) {
    let inputState = productQuote.hmcInputValues;
    const updatedValue = inputState[name].tempValue;
    inputState[name].value = updatedValue;
    inputState[name].tempValue = null;
    SegmentAnalytics.trackHmcwEdit('Edit Selection Saved', 'Saved', name, updatedValue);

    dispatchSetHelpMeChooseInput(inputState);
    handleSubmit(event);
  }

  function cancelChange(name) {
    let inputState = productQuote.hmcInputValues;
    inputState[name].tempValue = null;
    inputState[name].error = false;
    SegmentAnalytics.trackHmcwEdit('Edit Selection Cancelled', 'Cancelled', name, null);

    dispatchSetHelpMeChooseInput(inputState);
  }

  function assignRecommendedPackage(inputValues) {
    let packageObject = { ...recommendedPackage };
    let industryPackages =
      product.productsConfig[FRIENDLY_NAME].configuration.industries[INDUSTRY_KEY].packages;
    if (industryPackages) {
      //filter features
      const liteFeatures = [...industryPackages['lite'].features.display];
      const baseFeatures = [...industryPackages['base'].features.display];
      const premiumFeatures = [...industryPackages['premium'].features.display];
      const proFeatures = [...industryPackages['pro'].features.display];

      if (inputValues.digitalProposals.value === 'Yes') {
        packageObject = industryPackages['pro'];
        packageObject.features.filteredDisplay = proFeatures.filter((b) => {
          let indexFound = baseFeatures.findIndex((a) => a.title === b.title);
          return indexFound == -1;
        });
      } else if (inputValues.geography.value.length > 1 || inputValues.directMarketing.value === 'Yes') {
        packageObject = industryPackages['premium'];
        packageObject.features.filteredDisplay = premiumFeatures.filter((b) => {
          let indexFound = baseFeatures.findIndex((a) => a.title === b.title);
          return indexFound == -1;
        });
      } else if (
        inputValues.geography.value.length < 2 &&
        inputValues.directMarketing.value === 'No' &&
        (inputValues.dataReports.value === 'Yes' ||
          inputValues.notify.value === 'Yes' ||
          inputValues.dataExports.value === 'Yes')
      ) {
        packageObject = industryPackages['base'];
        packageObject.features.filteredDisplay = baseFeatures.filter((b) => {
          let indexFound = liteFeatures.findIndex((a) => a.title === b.title);
          return indexFound == -1;
        });
      } else {
        packageObject = industryPackages['lite'];
        packageObject.features.filteredDisplay = packageObject.features.display;
      }
      setRecommendedPackage(packageObject);
      return packageObject;
    }
  }

  function fetchProductQuote(newRecommendedPackage) {
    let productId = product.productsConfig[FRIENDLY_NAME].id;

    let configurationBlob = {
      configuration: setConfigurationBlob(),
      product_id: parseInt(productId, 10)
    };

    configurationBlob.configuration.package = newRecommendedPackage.key;
    if (configurationBlob.configuration.package !== null) {
      dispatch(fetchQuote(configurationBlob, productId)).then(function () {
        setProductPackageQuote(productQuote.quoteById[productId]);
      });
    }
  }

  function extractValue(arr, prop) {
    let extractedValue = arr.map((item) => item[prop]);
    return extractedValue;
  }

  function setConfigurationBlob() {
    let configuration =
      product.productsConfig[FRIENDLY_NAME].quoteConfigurationTemplate.configuration;
    configuration.industry = INDUSTRY_KEY;

    // users chosen  from selection
    configuration.number_of_users = productQuote.hmcInputValues.employeeCount.value;
    configuration.package = recommendedPackage.key;
    if (recommendedPackage.key === 'premium') {
      configuration.geography.national = true;
    } else {
      configuration.geography.national = false;
      if (productQuote.hmcInputValues.geography.value.length < geographyOptions.length) {
        const geography = extractValue(productQuote.hmcInputValues.geography.value, 'value');
        configuration.geography.states = geography;
      }
    }

    setProductConfiguration(configuration);

    return configuration;
  }

  const scrollToTop = () => {
    setTimeout(() => {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } catch (error) {
        // just a fallback for older browsers
        window.scrollTo(0, 0);
      }
    }, 100);
  };

  const createOptions = (option) => {
    return { label: option, value: option };
  };

  useEffect(() => {
    switch (helpMeChoose) {
      case 'help-me-choose':
        dispatch(setHmcw('Partial'));
        SegmentAnalytics.analyticsHmcw('HMCW Step 1', FRIENDLY_NAME, INDUSTRY_KEY);
        setCurrentStep(1);
        scrollToTop();
        break;
      case 'help-me-choose-2':
        dispatch(setHmcw('Partial'));
        SegmentAnalytics.analyticsHmcw('HMCW Step 2', FRIENDLY_NAME, INDUSTRY_KEY);
        setCurrentStep(2);
        scrollToTop();
        break;
      case 'help-me-choose-3':
        dispatch(setHmcw('Partial'));
        SegmentAnalytics.analyticsHmcw('HMCW Step 3', FRIENDLY_NAME, INDUSTRY_KEY);
        setCurrentStep(3);
        scrollToTop();
        break;
      case 'help-me-choose-recommendation':
        dispatch(setHmcw('Full'));
        SegmentAnalytics.analyticsHmcw('HMCW Recommendation', FRIENDLY_NAME, INDUSTRY_KEY);
        setCurrentStep(4);
        handleSubmit();
        scrollToTop();
        break;
      default:
        dispatch(setHmcw('Partial'));
        setCurrentStep(1);
        scrollToTop();
        break;
    }
  }, [helpMeChoose]);

  useEffect(() => {
    if (/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent)) {
      setMobile(true);
    }

    dispatch(fetchProduct(FRIENDLY_NAME, null)).then(() => {
      let industryPackages =
        product.productsConfig[FRIENDLY_NAME].configuration.industries[INDUSTRY_KEY].packages;

      // map states to geo options
      const newGeographyOptions =
        industryPackages['base']['geography']['states'].map(createOptions);
      setGeographyOptions(newGeographyOptions);
    });

    if (productQuote.hmcInputValues) {
      // reset unsaved changes
      for (let key of Object.keys(productQuote.hmcInputValues)) {
        productQuote.hmcInputValues[key].tempValue = null;
      }
      dispatchSetHelpMeChooseInput(productQuote.hmcInputValues);
    }
  }, []);

  return (
    <div>
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='wizard-container'>
              <React.Fragment>
                <form onSubmit={handleSubmit}>
                  {currentStep === 1 && (
                    <StepOne
                      handleChange={handleChange}
                      inputValues={
                        productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS
                      }
                      geographyOptions={geographyOptions}
                      problemsOptions={problemsOptions}
                      mobile={mobile}
                    />
                  )}
                  {currentStep === 2 && (
                    <StepTwo
                      handleChange={handleChange}
                      inputValues={
                        productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS
                      }
                      mobile={mobile}
                    />
                  )}
                  {currentStep === 3 && (
                    <StepThree
                      handleChange={handleChange}
                      inputValues={
                        productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS
                      }
                      mobile={mobile}
                    />
                  )}
                  {currentStep === 4 && (
                    <StepFour
                      currentStep={currentStep}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      inputValues={
                        productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS
                      }
                      handleEditChange={handleEditChange}
                      saveChange={saveChange}
                      cancelChange={cancelChange}
                      geographyOptions={geographyOptions}
                      recommendedPackage={recommendedPackage}
                      product={product}
                      FRIENDLY_NAME={FRIENDLY_NAME}
                      productQuote={productPackageQuote}
                      productConfiguration={productConfiguration}
                      productLoading={productQuote.loading}
                      showModal={showModal}
                      setModal={setModal}
                      coupon={coupon}
                      trackStep={SegmentAnalytics.trackStep}
                      trackHmcwEdit={SegmentAnalytics.trackHmcwEdit}
                      isValid={isValid}
                      dispatchSetHelpMeChooseInput={dispatchSetHelpMeChooseInput}
                    />
                  )}
                  <WizardButtons
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    inputValues={
                      productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS
                    }
                    isValid={isValid}
                    handleValidation={handleValidation}
                    handleSubmit={handleSubmit}
                    setConfigurationBlob={setConfigurationBlob}
                    product={product}
                    FRIENDLY_NAME={FRIENDLY_NAME}
                    trackStep={SegmentAnalytics.trackStep}
                    trackStepResponse={SegmentAnalytics.trackStepResponse}
                    trackHmcwAddToCart={SegmentAnalytics.trackHmcwAddToCart}
                    trackHmcwEdit={SegmentAnalytics.trackHmcwEdit}
                    mobile={mobile}
                    setHelpMeChooseInput={dispatchSetHelpMeChooseInput}
                  />
                </form>
              </React.Fragment>
            </div>
            <FooterComponent
              currentStep={currentStep}
              FRIENDLY_NAME={FRIENDLY_NAME}
              method={product.method}
              inputValues={
                productQuote.hmcInputValues ? productQuote.hmcInputValues : STEP_FORM_FIELDS
              }
              trackStep={SegmentAnalytics.trackStep}
              trackStepResponse={SegmentAnalytics.trackStepResponse}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpMeChooseWizardPage;
